module.exports = {
  'pending': 'Pendente',
  'wait-payment': 'Aguardando pagamento',
  'preparing': 'Sendo preparado',
  'ready-withdraw': 'Pronto para ser retirado',
  'transport': 'Em transporte',
  'done': 'Concluído',
  'canceled': 'Cancelado'
}